/* eslint-disable no-unused-vars */
import {
  Box,
  Card,
  CardContent,
  Grid,
  Tab,
  Tabs,
  Typography,
  CircularProgress
} from "@mui/material";
import PCheck from "../../../../components/pos/PCheck";
import PConfirm from "../../../../components/pos/PConfirm";
import PDialog from "../../../../components/pos/PDialog";
import PText from "../../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../../utils/API";
import { SyncUtils } from "../../../../utils/SyncUtils";
import { makeStyles } from "@mui/styles";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { t } = useTranslation();
  const translate = t;
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: 224,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

export default function RoleCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState(translate("New Role"));
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [privData, setPrivData] = useState([]);
  const [value, setValue] = React.useState(0);
  const [reports, setReports] = React.useState([]);
  const [selectedReports, setSelectedReports] = React.useState({});

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showRoleCrudWindow: showRoleCrudWindow,
  };

  useEffect(() => {
    console.log("Reports mountes", reports, origObject);
    if (origObject && reports && reports.length > 0) {
      let dbPrivs = JSON.parse(origObject.reportPrivilege);
      console.log(dbPrivs);
      let v = {};
      for (let r of reports) {
        for (let n of r.children) {
          console.log(n);
          v[n.name] = getValue({ name: n.name, type: "Boolean" }, dbPrivs);
        }
      }
      console.log(v);
      setSelectedReports(v);
    }
  }, [reports, origObject]);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);
  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  async function showRoleCrudWindow(roleId) {
    if (roleId == null) {
      resetFields();
      setOrigObject(null);
      setMode("create");
      populateRole(null);
      setWindowTitile("New Role");
      setLiveValidation(false);
      setOpenWindow(true);
      setSelectedReports({});
    } else {
      setMode("edit");
      populateRole(roleId);
    }
  }
  function getIndex(privs, groupName) {
    for (let i = 0; i < privs.length; i++) {
      if (privs[i].group === groupName) {
        return i;
      }
    }
    return null;
  }
  async function populateRole(id) {
    setSelectedReports({});
    let dbPrivs;
    if (id) {
      try {
        let { data } = await API.get("/auth/v1/role/" + id);
        dbPrivs = JSON.parse(data.privilege);
        setOrigObject(data);
        populateData(data, id);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Role data from server")
        );
      }
    }

    let { data } = await API.get("/auth/v1/role/privileges");
    let privs = [];

    let allPrivs = {};

    for (let d of data) {
      allPrivs[d.name] = getValue(d, dbPrivs);
      if (d.hide) {
        continue;
      }
      let index = getIndex(privs, d.group);
      // console.log("ROLE-INDEX", dbPrivs);
      if (index == null) {
        privs.push({
          group: d.group,
          children: [
            {
              key: d.name,
              label: d.label,
              dataType: d.type,
              value: getValue(d, dbPrivs),
            },
          ],
        });
      } else {
        privs[index].children.push({
          label: d.label,
          dataType: d.type,
          value: getValue(d, dbPrivs),
          key: d.name,
        });
      }
    }
    setPrivData(privs);
    console.log(allPrivs);

    let v = {};

    let res = await API.get("/report/available");
    let r = [];
    for (var key in res.data) {
      if (
        res.data.hasOwnProperty(key) &&
        key != "generic" &&
        key != "analytics"
      ) {
        r.push(res.data[key]);
        for (let rpt of res.data[key].children) {
          console.log(rpt);
          v[rpt.name] = allPrivs[rpt.name] ? true : false;
          //if(rpt.name==)
        }
      }
    }
    console.log(v);
    setReports(r);
    //setSelectedReports(v);
  }
  function getValue(d, dbPrivs) {
    // console.log("ROLE-", dbPrivs);
    //console.log("ROLE-", d);
    if (dbPrivs) {
      if (dbPrivs[d.name]) {
        if (d.type == "Boolean") return dbPrivs[d.name] === "true";
        else if (d.type == "String") return dbPrivs[d.name];
      }
      if (d.type == "Boolean") return d.defaultValue === "true";
      else if (d.type == "String") return d.defaultValue;
    } else {
      if (d.type == "Boolean") return d.defaultValue === "true";
      else if (d.type == "String") return d.defaultValue;
    }
  }
  function populateData(bean, id) {
    setName(bean.name);
    if (id) setWindowTitile(bean.name);

    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: "Are You Sure",
      message:
        translate("Are you sure to delete role") +
        " :" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/auth/v1/role/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Role") + " " + name + " " + translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete Role"));
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/auth/v1/role", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        props.onRefresh();
        setOpenWindow(false);
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save Role"));
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["name"] = name;
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    let privs = {};
    let rptPrivs = {};

    for (let d of privData) {
      for (let c of d.children) {
        if (c.dataType == "Boolean") privs[c.key] = c.value ? "true" : "false";
        else privs[c.key] = c.value;
      }
      for (var key in selectedReports) {
        rptPrivs[key] = selectedReports[key] ? "true" : "false";
      }
    }
    saveObject["privilege"] = JSON.stringify(privs);
    saveObject["reportPrivilege"] = JSON.stringify(rptPrivs);

    saveObject["showOnUi"] = true;
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["version"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["version"] = origObject.version;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError("Name is Required");
      flag = false;
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }
  function onCheckboxClicked(key, value) {
    let arr = [...privData];
    for (let a of arr) {
      for (let c of a.children) {
        if (c.key === key) {
          c.value = value;
        }
      }
    }
    setPrivData(arr);
  }

  function onTextChanged(key, value) {
    let arr = [...privData];
    for (let a of arr) {
      for (let c of a.children) {
        if (c.key === key) {
          c.value = value;
        }
      }
    }
    setPrivData(arr);
  }

  const classes = useStyles();

  const content = (
    <Grid container spacing={3}>
      <Grid item xs={2}>
        <Typography variant="body1">{translate("Name")}</Typography>
      </Grid>
      <Grid item xs={4}>
        <PText
          value={name}
          error={nameError}
          onChange={(e) => setName(e.target.value)}
        ></PText>
      </Grid>
      <Grid item xs={12}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          className={classes.tabs}
        >
          <Tab label={translate("General")} {...a11yProps(0)} />
          <Tab label={translate("Reports")} {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={value} index={0} style={{ width: "100%" }}>
          <Grid container>
            {privData.map((d) => (
              <Grid item xs={12} key={d.group}>
                <Grid container>
                  <Grid item xs={2}>
                    {d.group}
                  </Grid>
                  <Grid item xs={10}>
                    <Card style={{ marginRight: 5 }}>
                      <CardContent>
                        <Grid container>
                          {d.children.map((d) => (
                            <Grid item xs={4} key={d}>
                              {d.dataType == "Boolean" && (
                                <PCheck
                                  key={d.key}
                                  onChange={(value) =>
                                    onCheckboxClicked(d.key, value)
                                  }
                                  checked={d.value}
                                  label={d.label}
                                ></PCheck>
                              )}
                              {d.dataType == "String" && (
                                <table>
                                  <tr>
                                    <td>{d.label}</td>
                                    <td>
                                      <PText
                                        value={d.value}
                                        onChange={(e) => {
                                          onTextChanged(d.key, e.target.value);
                                        }}
                                      ></PText>
                                    </td>
                                  </tr>
                                </table>
                              )}
                            </Grid>
                          ))}
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1} style={{ width: "100%" }}>
          {reports.map((report, reportix) => (
            <Grid container>
              <Grid item xs={12}>
                {report.config.label}
              </Grid>
              <Grid item xs={12}>
                {report.children.map((childReport, reportix) => (
                  <Grid container>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={11}>
                      <PCheck
                        key={childReport.config.label}
                        onChange={(value) => {
                          let v = { ...selectedReports };
                          v[childReport.name] = value;
                          setSelectedReports(v);
                        }}
                        checked={selectedReports[childReport.name]}
                        label={childReport.config.label}
                      ></PCheck>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          ))}
        </TabPanel>
      </Grid>
    </Grid>
  );

  function isDataChanged() {
    /*if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }*/
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
